import { render, staticRenderFns } from "./DeleteEntityForm.vue?vue&type=template&id=cb56426e&scoped=true&"
import script from "./DeleteEntityForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./DeleteEntityForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56426e",
  null
  
)

export default component.exports